function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import MaterialSwitch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
import React from 'react';
/**
 * The `<Switch>` component allows a user to toggle the state of a setting on
 * or off.
 *
 * ```js
 * import { Switch } from '@theconversation/ui'
 *
 * <Switch onChange={alert('changed')} />
 * ```
 */

var Switch = function Switch(_ref) {
  var colour = _ref.colour,
      other = _objectWithoutProperties(_ref, ["colour"]);

  return React.createElement(MaterialSwitch, _extends({
    color: colour
  }, other));
};

Switch.propTypes = {
  /**
   * A boolean value indicating whether the switch is checked.
   */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   * Overrides the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The colour of the switch.
   */
  colour: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * A boolean value indicating whether the switch is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * A boolean value indicating whether the ripple effect is enabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The callback function called when the switch changes.
   */
  onChange: PropTypes.func,

  /**
   * The value of the component.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};
Switch.defaultProps = {
  checked: false,
  colour: 'default',
  disabled: false,
  disableRipple: false
};
export default Switch;